'use client'

import { Button, FormattedMessage } from '@b-stock/fe-core/bstock-react'

import {
  useSearchSimilarListingsHandler,
  type SimilarListingsProps,
} from './useSearchSimilarListingsHandler'

/**
 * - Opens /all-auctions in a new tab with query params for search term and condition filter
 * - Search query: top category from the listing
 * - Condition: JSON-stringified array for filter chips
 * - Storefront: When promoteOtherListings is 'own', adds storefront filter to show only listings from the same seller
 */
export const SimilarListingsButton = ({
  searchQuery,
  condition,
  categories,
  promoteOtherListings,
  storefront,
  variant,
  screenName,
  appearance = 'secondary',
  size = 'small',
}: SimilarListingsProps & {
  appearance?: 'primary' | 'secondary'
  size?: 'small' | 'medium'
}) => {
  const handleClick = useSearchSimilarListingsHandler({
    searchQuery,
    condition,
    categories,
    promoteOtherListings,
    storefront,
    variant,
    screenName,
  })

  return (
    <Button
      onClick={handleClick}
      type="button"
      appearance={appearance}
      size={size}
    >
      <FormattedMessage id="Listing.searchSimilar.findSimilarListings" />
    </Button>
  )
}
